import _ from "lodash";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const useAuth = () => {
  const location = useLocation();
  const pathname = location.pathname.split("/")[1];
  const userObjectStorgae = localStorage.getItem("userObject");
  if (!userObjectStorgae) {
    return false;
  }

  let token = null;
  let userUrl = [];
  let userObject = {};
  if (userObjectStorgae) {
    userObject = JSON.parse(userObjectStorgae);
    token = userObject.token;
    userUrl = userObject.userUrl;
  }
  userUrl = [{ path: "/" }, ...userUrl.map((item) => ({ path: item.url }))];
  const accessable = _.filter(userUrl, (url) => {
    return url.path.includes(pathname);
  });
  let code = 403;
  if (token && accessable.length > 0) {
    code = 200;
  }

  return { code };
};

const ProtectedRoutes = () => {
  const auth = useAuth();

  return auth.code === 200 ? (
    <Outlet />
  ) : auth.code === 403 ? (
    <Navigate to="/permissionDeny" />
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoutes;
